import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/exploration/')({
  beforeLoad: () => {
    throw redirect({ to: '/classic-guide/exploration' });
  },
});
